import { Injectable } from '@angular/core';
import { Http, L10n, QueryHandlerFor, Wrapper } from '@skylab-angular-shared/core';
import { PaymentMethodBaseQuery, PaymentMethodBaseQueryHandlerBase } from '@skylab-shared/business';
export { PaymentMethodBaseQueryHandlerBase };

@Injectable({ providedIn: 'root'})
@QueryHandlerFor(PaymentMethodBaseQuery)
@Wrapper(PaymentMethodBaseQueryHandlerBase)
export class PaymentMethodBaseQueryHandler {
    public constructor(
        http: Http,
        l10n: L10n
    ) { }
}
